export default "CEE Collectifs Copropriétés — Primes pour travaux d'économies d'énergie en immeuble | Solution Éco France";
